import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AdvancedSearchService {
  baseUrl: string = environment.baseUrl;
  constructor(private http: HttpClient) {}

  getNameSearchHistory(
    page: any,
    limit: any,
    searchKey?: any,
    searchValue?: any,
    startDate?: any,
    endDate?: any,
  ): Observable<any> {
    let params = new HttpParams().set('page', page).set('size', limit);

    if (searchKey) {
      params = params.set('search_key', searchKey);
    }

    if (searchValue) {
      params = params.set('search_value', searchValue);
    }

    if (startDate) {
      params = params.set('start_date', startDate);
    }

    if (endDate) {
      params = params.set('end_date', endDate);
    }

    return this.http.get(`${this.baseUrl}/name/history`, { params });
  }

  searchName(payload: any) {
    return this.http.post(`${this.baseUrl}/name/search`, payload);
  }

  deleteNameSearchHistory(payload: any) {
    return this.http.delete(`${this.baseUrl}/name/delete`, {
      body: payload,
    });
  }

  getSearchResults(jobIds: string[]): Observable<any> {
    return this.http.get(`${this.baseUrl}/name/job?job_id=${jobIds[0]}`);
  }

  getCompletedSearchResult(
    searchId: string,
    page?: number,
    options?: { jobId?: string },
  ): Observable<any> {
    let params = new HttpParams();
    if (searchId) {
      params = params.set('name_search_id', searchId);
    } else if (options?.jobId) {
      params = params.set('job_id', options.jobId);
    }
    if (page) {
      params = params.set('page', page);
    }
    return this.http.get(`${this.baseUrl}/name/results/`, { params });
  }

  exportSearchResult(searchId: string, format: string): Observable<any> {
    const params = new HttpParams()
      .set('is_export', true)
      .set('format', format);

    return this.http.get(`${this.baseUrl}/name/results/${searchId}`, {
      params,
    });
  }

  updateNameNotes(payload: any): Observable<any> {
    return this.http.put(`${this.baseUrl}/name/update`, payload);
  }
}

